export interface IconProps {
  width?: number;
  height?: number;
}

export default function HorizontalSeparatorIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.75"
      height="6"
      data-name="Horizontal Separator"
      viewBox="0 0 17.75 6"
    >
      <rect
        width="16"
        height="1.75"
        fill="currentColor"
        data-name="Rectangle 1916"
        rx="0.5"
        transform="translate(.875 2.125)"
      ></rect>
      <rect
        width="6"
        height="1.75"
        fill="currentColor"
        data-name="Rectangle 1916"
        rx="0.5"
        transform="rotate(90 .875 .875)"
      ></rect>
      <rect
        width="6"
        height="1.75"
        fill="currentColor"
        data-name="Rectangle 1916"
        rx="0.5"
        transform="rotate(90 8.875 8.875)"
      ></rect>
    </svg>
  );
}
